import { pageInitializedSignal } from './PageProgressed';

export function PageInitialized({
  pageId,
  appUid,
}: {
  pageId: string;
  appUid: string;
}) {
  pageInitializedSignal[appUid][pageId].set(true);
  return null;
}
